var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComputerPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 17,
  viewBox: "0 0 24 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 3.2511C1 2.00785 2.00785 1 3.2511 1H17.7489C18.9922 1 20 2.00785 20 3.2511V11.4156C20 12.6588 18.9922 13.6667 17.7489 13.6667H3.25109C2.00785 13.6667 1 12.6588 1 11.4156V3.2511Z",
  stroke: "#3A414C",
  strokeWidth: 1.62079
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.26996 15.8831H14.11",
  stroke: "#3A414C",
  strokeWidth: 1.62079,
  strokeLinecap: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 12,
  r: 4,
  fill: "#F7F8F8"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 10L21.6667 12L19 14V10Z",
  stroke: "#3A414C",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgComputerPlay as ReactComponent };
export default __webpack_public_path__ + "static/media/computerPlay.bf070477.svg";